
import React, { Component } from 'react';

 
const Gpsdata = (props) => {
    const handleEventClick = (e) => {
        e.stopPropagation();
        //console.log("Overspeed ",props);
        props.context.componentParent.onShowNoGPSKpi(props);
    };
    
   
            var colr = 'grayfont'
       
    //}
    return (
        <div>
            <button onClick={handleEventClick} className="custom-btn f22 label label-success" 
            title="GPS Available" ><i className={"icofont icofont-social-google-map "+(colr)}></i> &nbsp;</button>
            
        </div>
    );
};

export default Gpsdata;
